<template>
  <div class="page-wrapper">
    <div class="page-header"></div>
    <div class="page-body">
      <div class="tabs-widget">
        <div class="tabs-links">
          <div class="tab" style="justify-content: flex-start" :class="{ active: tab_type == 'public' }"
            @click="switchTab('public')">
            <span class="name">Summary</span>
          </div>
          <div class="tab" :class="{
                      active:
                        tab_type == 'students' ||
                        $route.query.profile_type == 'student',
                    }" @click="switchTab('students')">
            <span class="name">Consultants</span>
          </div>
          <div class="tab" v-if="$checkUserPermission('super-manager')" :class="{
                      active:
                        tab_type == 'instructors' ||
                        $route.query.profile_type == 'instructor',
                    }" @click="switchTab('instructors')">
            <span class="name">Managers</span>
          </div>
          <div class="tab" :class="{ active: tab_type == 'project' }" @click="switchTab('project')">
            <span class="name">Projects</span>
          </div>
          <div class="tab" :class="{ active: tab_type == 'skills' }" @click="switchTab('skills')">
            <span class="name">Skills</span>
          </div>
          <div class="tab" :class="{
                      active: tab_type == 'teams' || $route.name == 'view-team',
                    }" @click="switchTab('teams')">
            <span class="name">Teams</span>
          </div>
        </div>
      </div>
      <div class="tab-body">
        <!-- General info -->
        <general-information v-if="tab_type == 'public'" />
        <!-- End of genelar info -->

        <!-- Consultants -->
        <Consultants v-if="tab_type == 'students'" />
        <!-- End of Consultants -->

        <!-- Managers -->
        <Instructors v-if="tab_type == 'instructors'" />
        <!-- End of Instuctors -->

        <!-- Skills -->
        <Skills v-if="tab_type == 'skills'" />
        <!-- End of Skills -->

        <!-- Projects -->
        <Projects v-if="tab_type == 'project'" />
        <!-- End of Projects -->

        <!-- View consultant -->
        <ManageConsultant v-if="tab_type == 'manage'" />

        <!-- Teams -->
        <Teams v-if="tab_type == 'teams'"></Teams>
      </div>
    </div>
  </div>
</template>
<script>
import generalInformation from "./components/generalInformation.vue";
import Consultants from "./components/Consultants.vue";
import Skills from "./components/Skills.vue";
import Projects from "./components/Projects.vue";
import Instructors from "./components/Instructors.vue";
import Teams from "./components/Teams.vue";
import ManageConsultant from "./components/ManageConsultant.vue";

export default {
  name: "dashboard",
  components: {
    generalInformation,
    Consultants,
    Instructors,
    Skills,
    Projects,
    Teams,
    ManageConsultant,
  },
  data() {
    return {
      tab_type: "students",
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.tab_type = val;
    },
  },
  created() {
    let vm = this;
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    } else {
      vm.switchTab("students");
    }
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    }
    let path = [
      {
        label: "Company",
      },
    ];
    vm.$store.commit("SET_PATH", path);
  },
  methods: {
    onScoll({ target }) {
      // Modify header according to profile scoll
      let vm = this;
      vm.isScoll = true;
    },
    switchTab(type) {
      let vm = this;
      let path = [
        {
          label: "Company",
        },
        {
          label: type == "teams" ? "Teams" : type,
          active: true,
        },
      ];
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({ name: "organization", params: { type: type } })
        .catch((error) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    margin-top: 5px;
    height: calc(100% - 45px);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;

    .tabs-widget {
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 5px;
      width: 134px;
      border-bottom: 1px solid #efefef;
      height: max-content;
      padding: 18px 16px;

      .tabs-links {
        height: calc(100% - 168px);

        @media (min-width: 300px) and (max-width: 630px) {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: unset;
          overflow-y: unset;
        }

        .tab {
          cursor: pointer;
          height: 35px;
          display: flex;
          align-items: center;
          // border-left: 3px solid #eff1f8;
          position: relative;

          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
          }

          .name {
            display: block;
            color: #707070;

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }
        }

        .tab:hover {
          // border-left: 3px solid #1ba5a4;
          transition: 0.3s ease-in-out;

          .name {
            color: #1ba5a4;
            transition: 0.3s ease-in-out;
          }
        }

        .tab.active {

          // &::after {
          //   content: "";
          //   position: absolute;
          //   width: 5px;
          //   height: 100%;
          //   background: #1ba5a4;
          //   bottom: 0px;
          //   left: -4px;
          //   border-radius: 14px;
          // }
          .name {
            color: #1ba5a4;
          }

          .icon {
            background: #1890a9;
          }
        }
      }
    }

    .tab-body {
      width: calc(100% - 139px);
      height: 100%;
      padding: 0px !important;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>

